<!-- <app-spinner [show]=showSpinner [size]="150"> </app-spinner> -->
<form [formGroup]="form">
  <div class="container comm-methods-scope">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12" style="padding-right: 20px;">

        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-6">
            <mat-form-field class="clsGapping">
              <mat-label>My Cell Phone: </mat-label>
              <input matInput formControlName="CellNumber" required maxlength="10" minlength="10" (keypress)="onlyNumbersAllowed($event)" numbersonlyChecker>
              <mat-error *ngIf="getCellNumber.errors?.required">Enter Valid Cell Number</mat-error>
              <mat-error *ngIf="form.controls.CellNumber.hasError('minlength')">Allowed length is 10 digits (without country code).</mat-error>
            </mat-form-field>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-6">
            <mat-form-field class="clsGapping">
              <mat-label>Email: </mat-label>
              <input matInput type="text" formControlName="Email" required maxlength="100" readonly>
              <mat-error *ngIf="form.controls.Email.touched && form.controls.Email.hasError('required')">Email id is required</mat-error>
              <mat-error *ngIf="form.controls.Email.touched && form.controls.Email.hasError('email')">Please provide valid email Id</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="clsGapping">
              <mat-label>** Consent for World of Webinars, Hosts to text me: </mat-label>
              <mat-radio-group formControlName="TextConsent" class="clsGapping" aria-label="Select an option">
                <mat-radio-button class="margin" value="true">yes</mat-radio-button>
                <mat-radio-button class="margin" value="false">No</mat-radio-button>
              </mat-radio-group>

            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="clsGapping">
              <mat-label>** I agree, I am the cell phone owner listed above to which my consent was provided: </mat-label>
              <mat-radio-group formControlName="CellNumConcent" class="clsGapping" aria-label="Select an option">
                <mat-radio-button class="margin" value="true">yes</mat-radio-button>
                <mat-radio-button class="margin" value="false">No</mat-radio-button>
              </mat-radio-group>

            </div>
          </div>
        </div>
        <div class="row align-right-end">
          <div class="col-md-12">
            <button type="button" class="account-cta" (click)="SaveCommunicationMethod()">Save Details</button>
          </div>
        </div>
        <div class="row align-right-end">
          <div class="col-md-12 legal-copy">
            “By submitting your phone number to WOW, you agree to receive product notification messages from WOW. 
            Message and data rates may apply. Message frequency may vary. 
            You can unsubscribe at any time by replying STOP or by selecting ‘No’ for 
            ‘Consent for World of Webinars Hosts to text me.’ Reply HELP for assistance.”  
            <a [attr.href]="policyLink">Privacy Policy</a> & <a [attr.href]="termsandconditions">Terms</a>."
          </div>
        </div>
      </div>
    </div>
  </div>
</form>